import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';
import { GlobalQuestionService } from '../../services/global-question.service';
import { ComponentsService } from '../../services/components-service';
import { QuestionFlowSessionQuery } from '../state/question-flow-session.query';


@Component({
    selector: 'app-question-mini-form',
    templateUrl: './question-mini-form.component.html',
    styleUrls: ['./question-mini-form.component.scss'],
    standalone: false
})
export class QuestionMiniFormComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Output() questionAnswer = new EventEmitter();
  @Output() formSubmitted = new EventEmitter();

  uniqueControlName = `radio-name-${newGuid()}`;
  items: any[] = [];
  skipped = false;
  showSkip = false;
  questions = [];
  hasData = false;
  childrenQuestions  = [];
  itemsData = [];
  item_id = 0;
  session_id = '';
  class_id = 0;
  parameters: any;
  session_details: any;
  constructor(private questionService: GlobalQuestionService,
    private componentsService: ComponentsService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery
    ) { }

  ngOnInit(): void {
    
    if (this.question?.parameter){
      this.parameters = JSON.parse(this.question?.parameter);
    }
    console.log(this.question, this.parameters)
    this.questionService.spinner(true);
    this.session_details = this.questionFlowSessionQuery.getValue();
    this.session_id = this.session_details?.session_id;
    this.getMiniFormQuestions();
    this.componentsService.getMiniFormQuestion().subscribe( questions => {
      
      if (questions.every(q => q.answer)) {
        this.questionService.saveAnswersOnly(questions);
        //this.questionService.saveAnswer(this.session_id, this.question.cent_aq_question_id, this.question?.product_class_id, this.question?.item_id, 'MiniForm answered', 0, this.question?.comment, this.question?.flow_id, this.question?.response_parameters, this.question?.vaps_id,this.question?.location_id).subscribe();
        this.getMiniFormQuestions();
          this.question.answer = "Form submitted";
         
          this.questionAnswer.emit(this.question);
          //this.formSubmitted.emit(true);
      } 
    })
    
  }
  ngAfterViewInit(): void{
    // demo new dialog functionality
    // const addFamilyMemberModal = document.getElementById('mini-form-modal');

    // modal can be triggered by attaching data-toggle="dialog" to a clickable element, or by calling showModal() on the modal element
    
    // open modal
    // addFamilyMemberModal.showModal();

    // close modal
    // addFamilyMemberModal.close();

   
    // open callback
    // addFamilyMemberModal.addEventListener('dialog-open', function(){
    //     console.log('dialog opened');     
    // });
    
    // close callback
    // addFamilyMemberModal.addEventListener('close', function () {
    //     console.log('dialog closed');
    // });

  }
  getMiniFormQuestions(): void {
    this.questionService.spinner(true);
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    parameters.set('category_id', this.session_details?.category_id);
    parameters.set('group_id', this.session_details?.group_id);
    parameters.set('flow_id', this.question?.flow_id.toString());
    parameters.set('question_id', this.question?.cent_aq_question_id.toString());
    this.questionService.runCommandNew('getMiniForm_questions', parameters).subscribe(questions => {
        this.questions = JSON.parse(questions[0]?.flowquestions);
        if (this.questions?.length) {
          this.questions?.sort((a, b) => a.page_index > b.page_index ? 1 : a.page_index < b.page_index ? -1 : 0);
        }
        this.item_id = questions[0]?.item_id;
        this.class_id = questions[0]?.class_id;
        this.itemsData = [];
        if (this.item_id === 0){
          this.item_id += 1;
          this.questions.forEach(q => {
            q.item_id = this.item_id;
          });
          
          this.componentsService.setMiniFormQuestion(this.questions);
        }
        else{
          this.hasData = true;
          questions.forEach(q => {
            q.flowquestions = JSON.parse(q?.flowquestions);
            this.itemsData.push(q);
            this.item_id = q.item_id;
          });
          let question = JSON.stringify(this.question);
          this.question = JSON.parse(question);
          this.question.answer = "Yes";
          console.log(this.itemsData)
          this.questionAnswer.emit(this.question);

        }
        this.questionService.spinner(false);
        
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes?.question?.currentValue !== changes?.question?.previousValue) {
    //   this.question = changes?.question?.currentValue;
    //   if (this.question?.options) {
    //     this.items = parseOptions(this.question?.options
    //     );
    //     if (this.items?.length) {
    //       this.items.sort((a, b) => a.answer_order > b.answer_order ? 1 : a.answer_order < b.answer_order ? -1 : 0);
    //     }
    //   }
    // }
    // if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
    //   this.readOnly = changes?.readOnly?.currentValue;
    // }
    // if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
    //   this.showLabel = changes?.showLabel?.currentValue;
    // }
    // this.componentsService.getMiniFormQuestion().subscribe( questions => {
    //   console.log(questions)
    //   if (questions.every(q => q.answer)) {
    //     console.log(this.question, questions);
    //     //
    //     this.questionService.saveAnswersOnly(questions);
    //     this.itemsData.push(questions);
    //     this.questionAnswer.emit(this.question);
    //     this.hasData = true;
    //     console.log(this.itemsData);
    //     questions.forEach(q => {
    //       q.answer = '';
    //     });
    //     console.log(questions);
    //     this.componentsService.setMiniFormQuestion(questions);
    //   }
    // })
    
  }
  getParameter(item,text: string): any {
    let str = "";
    if (text !== 'delete' && text !== 'edit') {
      let questions = this.parameters.find(p => p.parameter === text)?.value.split('|');
      let flowquestions = this.itemsData.find(i => i.item_id === item.item_id)?.flowquestions;
      questions.forEach(q => {
        str += flowquestions?.find(x => x.cent_aq_question_id == q)?.answer + ' ';
      });
    }
    else {
      str = this.parameters.find(p => p.parameter === text)?.value;
    }
    return str;
  }
  addAnother(): void{
    this.item_id += 1;
    this.questions.forEach(q => {
      q.item_id = this.item_id;
      q.answer = '';
    });
    this.componentsService.setMiniFormQuestion(this.questions);
  }
  deleteItem(item: any): void {
    console.log(item);
    item?.flowquestions.forEach(q => {
      this.questionService.removeAnswer(this.session_id,q?.cent_aq_question_id,q?.answer_id,q.product_class_id,q?.item_id,q?.answer).subscribe();
    });
    this.getMiniFormQuestions();
  }
  editItem(item: any): void {
    console.log(item)
    this.componentsService.setMiniFormQuestion(item?.flowquestions);
  }
}
